/**
 * Вход и регистрация — на странице портала, как в верхней панели портала и других сервисах:
 * на *.3a-fb.info — https://start.3a-fb.info/login, в dev — /hub/login. returnUrl возвращает обратно.
 * Собственная форма /login генератора в prod недоступна (nginx уводит её на портал без returnUrl).
 */
const LOOP_GUARD_KEY = 'whitepage:portalLoginRedirectAt';
const LOOP_GUARD_MS = 30_000;

const isPortalHost = (hostname: string) => hostname === '3a-fb.info' || hostname.endsWith('.3a-fb.info');

export function portalLoginUrl({ register = false, returnUrl }: { register?: boolean; returnUrl?: string } = {}): string {
  const { protocol, hostname, origin, href } = window.location;
  const base = isPortalHost(hostname.toLowerCase()) ? `${protocol}//start.3a-fb.info/login` : `${origin}/hub/login`;
  const url = new URL(base);
  if (register) url.searchParams.set('tab', 'register');
  url.searchParams.set('returnUrl', returnUrl || href);
  return url.toString();
}

/** После входа на портале — в кабинет генератора. */
export const dashboardReturnUrl = () => `${window.location.origin}/dashboard`;

/**
 * Уводит на вход портала. Если только что уже уводили и вернулись без сессии (портал считает
 * пользователя вошедшим, а генератор сессию не получил), второй раз не уводим — иначе цикл.
 * @returns true, если переход начат.
 */
export function redirectToPortalLogin(): boolean {
  let last = 0;
  try { last = Number(sessionStorage.getItem(LOOP_GUARD_KEY)) || 0; } catch { /* без sessionStorage защита не работает */ }
  if (Date.now() - last < LOOP_GUARD_MS) return false;
  try { sessionStorage.setItem(LOOP_GUARD_KEY, String(Date.now())); } catch { /* no-op */ }
  window.location.replace(portalLoginUrl());
  return true;
}

/** Сессия подтверждена — следующий уход на вход снова разрешён. */
export function clearPortalLoginGuard(): void {
  try { sessionStorage.removeItem(LOOP_GUARD_KEY); } catch { /* no-op */ }
}
